export const FAMILIES_PAGE_SIZE = 5;
export const calculateSkip = (page: number) => {
  return (page - 1) * FAMILIES_PAGE_SIZE;
};
export const calculatePages = (rows: number) => {
  return Math.ceil(rows / FAMILIES_PAGE_SIZE);
};
